<div class="barra-titulo">
  <app-ng-dynamic-breadcrumb
    [bgColor]="fondoTransparente"
    [fontSize]="'14px'"
    [fontColor]="colorEnlace"
    [lastLinkColor]="colorActual"
    [symbol]="' ' + separador + ' '">
  </app-ng-dynamic-breadcrumb>
</div>
